var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-operate" }, [
    _c(
      "div",
      {
        staticClass: "c-operate__item",
        class: { "is-disabled": _vm.isDisabled },
      },
      [
        _c("IconByTooltip", {
          staticClass: "iconfont_wrap",
          attrs: {
            data: { ..._vm.copyData, icon: "copyIcon", label: "复制" },
            copyValue:
              _vm.dataProp.content && _vm.dataProp.content[0]
                ? _vm.dataProp.content[0].value
                : "",
          },
          on: {
            "on-change": (e) => {
              _vm.copyData.isCopy = false
              _vm.copyData.className = "iconfont icon-a-fuzhimoren"
            },
            "on-click": () => {
              if (_vm.isDisabled) return
              _vm.copyData.isCopy = true
              _vm.copyData.className = "iconfont icon-a-yifuzhimoren"
            },
          },
        }),
      ],
      1
    ),
    (_vm.$attrs.isShowReset !== undefined ? _vm.$attrs.isShowReset : true)
      ? _c(
          "div",
          {
            staticClass: "c-operate__item",
            class: { "is-disabled": _vm.isDisabled },
          },
          [
            _c("IconByTooltip", {
              staticClass: "iconfont_wrap",
              attrs: {
                data: {
                  className: "iconfont icon-a-shuaxinmoren",
                  placement: "top",
                  label: _vm.isDisabled ? "生成中，不可操作" : "重新生成",
                  icon: "congxinshengchengIcon",
                },
              },
              on: {
                "on-click": () => {
                  if (_vm.isDisabled) return
                  _vm.$emit("on-reset-question", {
                    params: { ..._vm.dataProp, index: _vm.indexProp },
                    formModalData: this.formModalDataProp,
                  })
                },
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _c("span", { staticClass: "c-operate__divider" }),
    _c(
      "div",
      {
        staticClass: "c-operate__item feedback-item",
        class: { "is-disabled": _vm.isDisabled },
      },
      [
        _c(
          "el-tooltip",
          {
            attrs: {
              effect: "dark",
              placement: "top",
              content: _vm.feedbackState === "like" ? "取消点赞" : "点赞",
            },
          },
          [
            _c(
              "div",
              {
                class: [
                  "feedback_btn",
                  "like-btn",
                  { active: _vm.feedbackState === "like" },
                ],
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    _vm.isDisabled || _vm.handleFeedback("like")
                  },
                },
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "16",
                      height: "16",
                      viewBox: "0 0 16 16",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M3.5 5.5H2.25C1.56 5.5 1 6.06 1 6.75V12.75C1 13.44 1.56 14 2.25 14H3.5V5.5Z",
                        stroke: "currentColor",
                        "stroke-width": "1.2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                      },
                    }),
                    _c("path", {
                      attrs: {
                        d: "M3.5 14L8 14C8.82843 14 9.5 13.3284 9.5 12.5V10C9.5 9.72386 9.27614 9.5 9 9.5H7L8 6C8.27614 4.89543 7.60457 3.5 6.5 3.5C6.22386 3.5 6 3.72386 6 4V5.5L3.5 5.5",
                        stroke: "currentColor",
                        "stroke-width": "1.2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                      },
                    }),
                  ]
                ),
              ]
            ),
          ]
        ),
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass: "c-operate__item feedback-item",
        class: { "is-disabled": _vm.isDisabled },
      },
      [
        _c(
          "el-tooltip",
          {
            attrs: {
              effect: "dark",
              placement: "top",
              content: _vm.feedbackState === "dislike" ? "取消点踩" : "点踩",
            },
          },
          [
            _c(
              "div",
              {
                class: [
                  "feedback_btn",
                  "dislike-btn",
                  { active: _vm.feedbackState === "dislike" },
                ],
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    _vm.isDisabled || _vm.handleFeedback("dislike")
                  },
                },
              },
              [
                _c(
                  "svg",
                  {
                    staticStyle: { transform: "translateY(2px)" },
                    attrs: {
                      width: "16",
                      height: "16",
                      viewBox: "0 0 16 16",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M3.5 10.5H2.25C1.56 10.5 1 9.94 1 9.25V3.25C1 2.56 1.56 2 2.25 2H3.5V10.5Z",
                        stroke: "currentColor",
                        "stroke-width": "1.2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                      },
                    }),
                    _c("path", {
                      attrs: {
                        d: "M3.5 2H8C8.82843 2 9.5 2.67157 9.5 3.5V6C9.5 6.27614 9.27614 6.5 9 6.5H7L8 10C8.27614 11.1046 7.39543 12.5 6.5 12.5C6.22386 12.5 6 12.2761 6 12V10.5L3.5 10.5",
                        stroke: "currentColor",
                        "stroke-width": "1.2",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                      },
                    }),
                  ]
                ),
              ]
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }